export const ACTIVATE_MENU_ITEM = 'ACTIVATE_MENU_ITEM'


export function activateMenuItem(selectedMenuItem) {
    return {
        type: ACTIVATE_MENU_ITEM,
        selectedMenuItem
    }
}
